import * as routerActions from 'connected-react-router'

// Schemas
import { commentSchema, commentListSchema } from 'modules/comments/models'

// Types
import { Dispatch, GetState, APIAction } from 'types'

export const actions = {
  _postComment: (content_type: string, object_id: number, text: string, parent: number | null | undefined = null): APIAction => ({
    CALL_API: {
      type: 'POST_COMMENT',
      method: 'POST',
      endpoint: '/api/comment/',
      schema: commentSchema,
      data: { content_type, object_id, text, parent },
    },
  }),

  postComment:
    (content_type: string, object_id: number, text: string, parent: number | null | undefined = null) =>
    (dispatch: Dispatch, getState: GetState) => {
      const state = getState()
      if (state.auth.isAuthenticated) {
        return dispatch(actions._postComment(content_type, object_id, text, parent))
      }
      const { pathname } = state.router.location
      return dispatch(routerActions.push(`${pathname}?modal=signup`))
    },

  fetchComments: (objectType: string, objectId: number): APIAction => ({
    CALL_API: {
      type: 'FETCH_COMMENTS',
      method: 'GET',
      endpoint: `/api/comment/?type=${objectType}&id=${objectId}`,
      schema: commentListSchema,
    },
  }),

  editComment: (commentId: number, text: string): APIAction => ({
    CALL_API: {
      type: 'EDIT_COMMENT',
      method: 'PATCH',
      endpoint: `/api/comment/${commentId}/`,
      schema: commentSchema,
      requestKey: commentId,
      data: { text },
    },
  }),

  deleteComment: (commentId: number): APIAction => ({
    CALL_API: {
      type: 'DELETE_COMMENT',
      method: 'POST',
      endpoint: `/api/comment/${commentId}/remove/`,
      schema: commentSchema,
    },
  }),

  flagComment: (commentId: number): APIAction => ({
    CALL_API: {
      type: 'FLAG_COMMENT',
      method: 'POST',
      endpoint: `/api/comment/${commentId}/flag/`,
      schema: commentSchema,
    },
  }),
}
